import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Panel from '../../../UniformComponents/Panel'

const EmailWizardModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.wizardEmailModalVisible}
        onClose={distributeStore.hideWizardEmailModal}
        style={{
            width: '460px',
        }}
    >
        <Typography type="h3">{i18n.t('distributionEmailWizardModal.title')}</Typography>

        <br />

        <div className="email-wizard-options">
            <Panel
                cssClass="email-wizard-option"
                onClick={distributeStore.wizardGoToBuilder}
            >
                <i
                    className="far fa-file-circle-plus"
                />

                <Typography type="b">{i18n.t('distributionEmailBuilder.create')}</Typography>
            </Panel>

            <Panel
                cssClass="email-wizard-option"
                onClick={distributeStore.wizardGoToLists}
            >
                <i
                    className="far fa-envelope-open-text"
                />

                <Typography type="b">{i18n.t('distributionEmailList.upload')}</Typography>
            </Panel>
        </div>
    </Modal>
)

export default observer(EmailWizardModal)
